import { render, staticRenderFns } from "./LoanedPlayer.vue?vue&type=template&id=8aaf09aa&scoped=true"
import script from "./LoanedPlayer.vue?vue&type=script&lang=js"
export * from "./LoanedPlayer.vue?vue&type=script&lang=js"
import style0 from "./LoanedPlayer.vue?vue&type=style&index=0&id=8aaf09aa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8aaf09aa",
  null
  
)

export default component.exports